module.exports = __webpack_public_path__ + "img/Feature.5d42057d.png";